<template>
  <div
    id="sidenav-collapse-main"
    class="collapse navbar-collapse w-auto h-auto h-100"
  >
    <ul class="navbar-nav">
    <!-- Dashboard -->
      <li class="nav-item">
        <sidenav-collapse
         ref=dashboardExpand
          collapse-ref="home"
          nav-text="Dashboard"
          tour-id="dashboardExpand"
          :class="getRoute() === 'dashboards' ? 'active' : ''"
        >
          <template #icon>
            <i class="fas fa-home text-primary text-sm opacity-10"></i>
          </template>
          <template #list>
            <ul class="nav ms-4">
              <!-- nav links -->

              <sidenav-item
                ref="dashboardOverview"
                :to="{ name: 'Home' }"
                mini-icon="C"
                text="Overview"
                tour-id="dashboardOverview"
              />
              <!--sidenav-item
                :to="{ name: 'Calendar' }"
                mini-icon="C"
                text="Calendar"
              /-->
              <!--sidenav-item
                :to="{ name: 'Metrics' }"
                mini-icon="D"
                text="Metrics"
              />
              <sidenav-item
                :to="{ name: 'Metrics' }"
                mini-icon="D"
                text="Download"
              /-->
            </ul>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse
          ref="proposalsExpand"
          collapse-ref="proposals"
          nav-text="Proposals"
          tour-id="proposalsExpand"
          :class="getRoute() === 'dashboards' ? 'active' : ''"
        >
          <template #icon>
            <i class="fas fa-file-alt text-primary text-sm opacity-10"></i>
          </template>
          <template #list>
            <ul class="nav ms-4">
              <!-- nav links -->
              <sidenav-item
                ref="newProposal"
                :to="{name: 'wasm'}"
                mini-icon="L"
                text="New Proposal"
                tour-id="newProposal"
              />
              <!--sidenav-item
                :to="{ name: 'resume' }"
                mini-icon="L"
                text="Resume Proposal"
                ref="resumeProposal"
                tour-id="resumeProposal"
              /-->
              <sidenav-item
                ref="allProposals"
                :to="{ name: 'Proposals Table' }"
                mini-icon="L"
                text="All Proposals"
                tour-id="allProposals"
              />
            </ul>
          </template>
        </sidenav-collapse>
      </li>

      <li v-if="isAiEnabled" class="nav-item">
        <sidenav-collapse
          collapse-ref="ai"
          nav-text="AI"
          :class="getRoute() === 'ai' ? 'active' : ''"
        >
          <template #icon>
            <i class="fas fa-robot text-primary text-sm opacity-10"></i>
          </template>
          <template #list>
            <ul class="nav ms-4">
              <sidenav-item
                v-if="isAiChatEnabled"
                :to="{ name: 'AI Chat' }"
                mini-icon="C"
                text="Chat"
              />
              <sidenav-item
                v-if="isAiAnalysisEnabled"
                :to="{ name: 'AI Analysis' }"
                mini-icon="A"
                text="Analysis"
              />
              <sidenav-item
                v-if="isAiReplacementCostEnabled"
                :to="{ name: 'Replacement Cost Calculator' }"
                mini-icon="R"
                text="RCV Calculator"
              />
            </ul>
          </template>
        </sidenav-collapse>
      </li>


      <li class="nav-item">
        <sidenav-collapse
        ref="goalsExpand"
        collapse-ref="goals"
        nav-text="Goals"
        tour-id="goalsExpand"
        >
        <template #icon>
            <i class="fas fa-award text-primary text-sm opacity-10"></i>
          </template>

          <template #list>
            <ul class="nav ms-4">
              <!-- nav links -->
              <!--sidenav-under-construction-item
              mini-icon="L"
              text="Key Metrics"
              /-->
              <sidenav-item v-if="isAgencyAdmin"
  ref="agencyAdminPlan"
  :to="{ name: 'Agency Plan' }"
  mini-icon="L"
  text="Agency Annual Plan"
  tour-id="agencyAdminPlan"
/>
<sidenav-item v-else
 ref="producerAdminPlan"
  :to="{ name: 'Business Plan' }"
  mini-icon="L"
  text="Producer Annual Plan"
  tour-id="producerAdminPlan"
/>
            </ul>
          </template>
        </sidenav-collapse>
      </li>



      <li class="nav-item">
        <!--router-link to="/manage" class="nav-link">
          <i class="fas fa-bullseye text-primary text-sm opacity-10"></i>
          <span class="nav-text">9 Bullets to Bind-it</span>
        </router-link-->

        <sidenav-collapse
          ref="emailMarketingExpand"
          collapse-ref="Email-Marketing"
          nav-text="Email Marketing (BETA)"
          tour-id="emailMarketingExpand"
        >
          <template #icon>
            <i class="fas fa-bullseye text-primary text-sm opacity-10"></i>
          </template>
          <template #list>
            <ul class="nav ms-4">
              <!-- nav links -->
              <sidenav-item
                ref="nineBullets"
                to="/manage"
                mini-icon="L"
                text="9 Bullets to Bind-it (BETA)"
                tour-id="nineBullets"
              />
              <sidenav-item
                ref="documentLibrary"
                :to="{ name: 'agency_library' }"
                mini-icon="C"
                text="Document Library"
                tour-id="documentLibrary"
              />
            </ul>
          </template>
        </sidenav-collapse>
      </li>

      <li class="mt-3 nav-item">
        <h6
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="$store.state.isRTL ? 'me-4' : 'ms-2'"
        >
        Tutorials & Coaching
        </h6>
      </li>

      <li class="nav-item">
      <a
        href="#"
        class="nav-link"
        @click.prevent="openTutorials"
      >
      <i class="fas fa-play-circle text-primary text-sm opacity-10"></i>
      <span class="nav-text">Tutorial Videos</span>
      </a>
      </li>

      <li class="nav-item">
      <a
        href="#"
        class="nav-link"
        @click.prevent="openCoachingWindow"
      >
      <i class="fas fa-chalkboard-teacher text-primary text-sm opacity-10"></i>
      <span class="nav-text">Preeminent Coaching</span>
      </a>
      </li>



      <li class="nav-item">
        <router-link to="/glossary" class="nav-link"> 
          <i class="fas fa-book text-primary text-sm opacity-10"></i>
          <span class="nav-text">Glossary</span>
        </router-link>
      </li>






      <li class="mt-3 nav-item">
        <h6
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="$store.state.isRTL ? 'me-4' : 'ms-2'"
        >
          MANAGEMENT & SUPPORT
        </h6>
      </li>


      <li v-if="isAdmin" class="nav-item">
        <sidenav-collapse
          collapse-ref="admin"
          nav-text="Admin"
          :class="getRoute() === 'dashboards' ? 'active' : ''"
        >
          <template #icon>
            <i class="fas fa-user-shield text-primary text-sm opacity-10"></i>
          </template>
          <template #list>
            <ul class="nav ms-4">
              <!-- nav links -->

              <sidenav-item
                :to="{ name: 'Agencies' }"
                mini-icon="C"
                text="Manage Agencies"
              />
              <sidenav-item
                :to="{ name: 'Users' }"
                mini-icon="C"
                text="Manage Users"
              />
              <sidenav-item
                :to="{ name: 'Invites' }"
                mini-icon="C"
                text="Manage Invites"
              />
            </ul>
          </template>
        </sidenav-collapse>
      </li>

      <li v-if="isAgencyAdmin" class="nav-item">
        <sidenav-collapse
          collapse-ref="agency"
          nav-text="Agency"
          :class="getRoute() === 'dashboards' ? 'active' : ''"
        >
          <template #icon>
            <i class="fas fa-user-shield text-primary text-sm opacity-10"></i>
          </template>
          <template #list>
            <ul class="nav ms-4">
              <!-- nav links -->


              <sidenav-item
                :to="{ name: 'Invite' }"
                mini-icon="C"
                text="Invite Member"
              />
              <sidenav-item
                :to="{ name: 'Edit Style' }"
                mini-icon="C"
                text="Edit Style"
              />
              <sidenav-item
                :to="{ name: 'Agency Members' }"
                mini-icon="C"
                text="Manage Members"
              />
              <sidenav-item
                :to="{ name: 'Agency Integrations' }"
                mini-icon="I"
                text="Integrations"
              />
              <sidenav-item
                :to="{ name: 'Agency Billing' }"
                mini-icon="B"
                text="Agency Billing"
              />
            </ul>
          </template>
        </sidenav-collapse>
      </li>


            <li class="nav-item">
        <sidenav-collapse
          collapse-ref="support"
          nav-text="Support"
          :class="getRoute() === 'dashboards' ? 'active' : ''"
        >
          <template #icon>
            <i class="ni ni-chat-round text-primary text-sm opacity-10"></i>
          </template>
          <template #list>
            <ul class="nav ms-4">
              <!-- nav links -->
              <!--sidenav-item
                :to="{ name: 'Landing' }"
                mini-icon="L"
                text="FAQs"
              />
              <sidenav-item
                :to="{ name: 'CRM' }"
                mini-icon="C"
                text="Send us a message"
              /-->

              <!--sidenav-under-construction-item
              mini-icon="L"
              text="FAQs"
              /-->
              <SideNavJSItem
              mini-icon="L"
              text="FAQs"
              :on-click="handleFAQs"
              />
              <!--sidenav-under-construction-item
              mini-icon="L"
              text="Send us a message"
              /-->

              <SideNavJSItem
              mini-icon="L"
              text="Send us a message"
              :on-click="handleSendMessage"
              />
              <SideNavJSItem
                mini-icon="L"
                text="Start Guided Tour"
                :on-click="startTour"
              />
            </ul>
          </template>
        </sidenav-collapse>
      </li>


    </ul>
    <glossary-modal :is-open="isGlossaryModalOpen" @close="closeGlossaryModal"></glossary-modal>

<div v-if="isTourOpen" class="tour-hud-overlay">
  <div class="hud-content">
    <button class="close-button" @click="finishTour">×</button>

    <div class="step-title text-center">
      {{ currentStepTitle }}
    </div>

    <div class="step-label">
      Step {{ currentStep }} of {{ totalSteps }}
    </div>

    <div class="progress-container">
      <div
        class="progress-bar"
        :style="{ width: totalSteps > 1 ? ((currentStep - 1) / (totalSteps - 1) * 100) + '%' : '100%' }"
      ></div>
    </div>

    <div class="button-row">
      <button
        class="nav-arrow"
        :disabled="currentStep === 1"
        @click="backStep"
      >&lt;</button>
      <button
        v-if="currentStep < totalSteps"
        class="nav-arrow"
        @click="nextStep"
      >&gt;</button>
      <button
        v-else
        class="nav-arrow"
        @click="finishTour"
      >✓</button>
    </div>
  </div>
</div>






  </div>
</template>
<script>
import SidenavItem from "./SidenavItem.vue";
import SidenavCollapse from "./SidenavCollapse.vue";
//import SidenavMagnetItem from './SidenavMagnetItem.vue';
//import SidenavUnderConstructionItem from './SidenavUnderConstructionItem.vue';
import SideNavJSItem from "./SideNavJSItem.vue";
import { TourService } from '../../services/tour.service'
import { isPublicAuthPath } from "@/utils/public-auth-routes";
import { getAccessToken } from "@/services/token.service";

export default {
  name: "SidenavList",
  components: {
    SidenavItem,
    SidenavCollapse,
    //SidenavMagnetItem,
    //SidenavUnderConstructionItem,
    SideNavJSItem
  },
  data() {
    return {
      isLoaded: false,
      isGlossaryModalOpen: false,
      isTourOpen: false,
      currentStep: 0,
      totalSteps: 0,
      currentStepTitle: 'test'

    };
  },

  computed: {
    role() {
      return this.$store.getters["profile/me"]?.roles[0].name;
    },
    userRole() {
      return this.$store.state.profile.me.role;
    },
    getUser() {
      return this.$store.getters["profile/me"];
    },
    isAdmin() {
      // Accessing user role from Vuex state
      return this.$store.getters['profile/me']?.role === 'global_admin';
    },
    isAgencyAdmin() {
      // Accessing user role from Vuex state
      return this.$store.getters['profile/me']?.role === 'agency_admin';
    },
    aiFeatures() {
      return this.$store.getters["profile/me"]?.ai_features || null;
    },
    isAiEnabled() {
      if (this.isAdmin) return true;
      return this.aiFeatures?.enabled === true;
    },
    isAiChatEnabled() {
      if (this.isAdmin) return true;
      return this.isAiEnabled && this.aiFeatures?.chat === true;
    },
    isAiAnalysisEnabled() {
      if (this.isAdmin) return true;
      return this.isAiEnabled && this.aiFeatures?.analysis === true;
    },
    isAiReplacementCostEnabled() {
      if (this.isAdmin) return true;
      return this.isAiEnabled && this.aiFeatures?.replacement_cost === true;
    }
  },
  created() {
    this.ensureDataReady();
  },
  async mounted() {
    const onPublicAuthPage = isPublicAuthPath(this.$route?.path || "");
    if (
      !onPublicAuthPage &&
      getAccessToken() &&
      !this.getUser &&
      this.$store.getters["auth/isAuthenticated"]
    ) {
      await this.$store.dispatch('profile/me').catch(error => {
        console.error("Failed to fetch user data: ", error);
        // Handle error, for example redirect or show error message
      });
    }
    this.isLoaded = true; // Set to true once the user data is ready


    TourService.registerAll(this, [
      'dashboardExpand',
      'dashboardOverview',
      'proposalsExpand',
      'newProposal',
      'allProposals',
      'goalsExpand',
      'agencyAdminPlan',
      'producerAdminPlan',
      'emailMarketingExpand',
      'nineBullets',
      'documentLibrary'
    ]);

    TourService.onStepChange((current, total, step) => {
      console.log(`Tour Step: ${current} of ${total}`);
        this.currentStep = current;
        this.totalSteps = total;
        console.log(step);
        this.currentStepTitle = step?.options?.title || 'test';
    });

    TourService.onComplete(() => {
      this.isTourOpen = false;
      //this.currentStep = 0;
      //this.totalSteps = 0;
    });
  },
  methods: {
    nextStep() {
      TourService.next()
    },
    backStep() {
      TourService.back()
    },
    finishTour() {
      TourService.complete()
    },

    startTour() {
      if (this.isTourOpen) return;

      this.isTourOpen = true;

      TourService.startTour(this, () => TourService.buildNavbarSteps(this.isAgencyAdmin));
    },


/*
  startTour() {
    if (this.isTourOpen) {
      return;
    }

    this.isTourOpen = true;

    this.tour = this.$shepherd({
      defaultStepOptions: {
        scrollTo: true,
        popperOptions: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 0]
              }
            }
          ]
        }
      }
    });
  //      attachTo: { element: this.$refs.dashboardExpand.getAnchor(), on: 'right-start' },

    let steps = [
      {
        id: 'step-expand-dashboard',
        attachTo: { element: TourService.get('dashboardExpand').getAnchor(), on: 'right-start' },
        title: 'Expand Dashboard',
        text: 'Click the Dashboard header to expand.',
        advanceOn: {
          selector: '[data-tour-id="dashboardExpand"]',
          event: 'click'
        }
      },
      {
        id: 'step-dashboard-overview',
        attachTo: { element: TourService.get('dashboardOverview').getAnchor(), on: 'right-start' },
        text: 'This page gives you a high-level summary of your metrics and current proposals.',
        buttons: [
          {
            text: 'Next',
            action: this.tour.next
          }
        ]
      },
      {
        id: 'step-expand-proposals',
        attachTo: { element: TourService.get('proposalsExpand').getAnchor(), on: 'right-start' },
        title: 'Expand Proposals',
        text: 'Click the Proposals header to expand.',
        advanceOn: {
          selector: '[data-tour-id="proposalsExpand"]',
          event: 'click'
        }
      },
      {
        id: 'step-new-proposal',
        attachTo: { element: TourService.get('newProposal').getAnchor(), on: 'right-start' },
        title: 'New Proposal',
        text: 'This is where you can start a new proposal.',
        buttons: [
          {
            text: 'Next',
            action: this.tour.next
          }
        ]
      },
      {
        id: 'step-all-proposals',
        attachTo: { element: TourService.get('allProposals').getAnchor(), on: 'right-start' },
        title: 'All Proposals',
        text: 'This is where all of your proposals live, including the archived or closed accounts...',
        buttons: [
          {
            text: 'Next',
            action: this.tour.next
          }
        ]
      },
      {
        id: 'step-expand-goals',
        attachTo: { element: TourService.get('goalsExpand').getAnchor(), on: 'right-start' },
        title: 'Expand Goals',
        text: 'Click the Goals header to expand.',
        advanceOn: {
          selector: '[data-tour-id="goalsExpand"]',
          event: 'click'
        }
      },
      {
        id: 'step-annual-plan',
        attachTo: {
          element: this.isAgencyAdmin
            ? TourService.get('agencyAdminPlan')?.getAnchor?.()
            : TourService.get('producerAdminPlan')?.getAnchor?.(),
          on: 'right-start'
        },
        title: this.isAgencyAdmin ? 'Agency Annual Plan' : 'Producer Annual Plan',
        text: this.isAgencyAdmin
          ? 'As an Agency Admin you can review the Agency Annual Plan or drill into individual Producer\'s Annual Plan. Growth is guaranteed if your agency is utilizing an Agency Plan correctly.'
          : 'This is your Producer Annual Plan it serves as a benchmark to reach your goals, and we keep track of your progress.',
        buttons: [{ text: 'Next', action: this.tour.next }]
      },

      {
        id: 'step-expand-email-marketing',
        attachTo: { element: TourService.get('emailMarketingExpand').getAnchor(), on: 'right-start' },
        title: 'Expand Email Marketing',
        text: 'Click the Email Marketing header to expand.',
        advanceOn: {
          selector: '[data-tour-id="emailMarketingExpand"]',
          event: 'click'
        }
      },
      {
        id: 'nine-bullets',
        attachTo: { element: TourService.get('nineBullets').getAnchor(), on: 'right-start' },
        title: '9 Bullets to Bind-it',
        text: '9 Bullets to Bind-it is our campaign automation feature, leveraging decision maker psychology 9 Bullets to bind-it is a Guaranteed solution to increase closing rate for new business.',
        buttons: [
          {
            text: 'Next',
            action: this.tour.next
          }
        ]
      },
      {
        id: 'document-library',
        attachTo: { element: TourService.get('documentLibrary').getAnchor(), on: 'right-start' },
        title: 'Document Library',
        text: 'The Document Library is where you can upload your own documents to either attach to proposals, or send send to prospects Via 9 Bullets to Bind-it.',
        buttons: [
          {
            text: 'Finish',
            action: this.tour.complete
          }
        ]
      },

    ];

    // Mutate the steps inline based on role
    steps = steps.filter(step => {
      if (step.adminOnly && !this.isAdmin) return false;
      if (step.agencAdminyOnly && !this.isAgencyAdmin) return false;
      return true;
    });

    this.tour.addSteps(steps);
    this.tour.start();
  },
*/
    handleFAQs() {
      this.$router.push({ name: "faq" });
    },

    handleSendMessage(event) {
      console.log("SidenavItem clicked!", event);
      const toggleElement = document.getElementById("hj-survey-toggle-1");
      if (toggleElement) {
        toggleElement.click(); // Trigger a click on the target element
      } else {
        console.error("Element with ID 'hj-survey-toggle-1' not found.");
      }
    },

    openTutorials() {
      const button = document.getElementById('invisibleTutButton');
    if (button) {
      button.click();
    }
    },
    async openCoachingWindow() {
  const newTab = window.open('', '_blank');

  if (newTab) {
    // Write loading screen content
    newTab.document.write(`
      <html>
        <head>
          <title>Loading...</title>
        </head>
        <body>
          <h1 style="text-align: center; margin-top: 20%;">Page is loading...</h1>
        </body>
      </html>
    `);
    newTab.document.close();

    // Redirect to the desired URL
    newTab.location.href = 'https://www.thepreeminentproducer.com/coaching';

    // Focus on the new tab after a short delay to allow the page to load
    setTimeout(() => {
      newTab.focus();
    }, 500); // 0.5-second delay for the new tab to load
  } else {
    alert('Popup blocked. Please allow popups for this site.');
  }
},

    onInteractiveAnalysisClick() {
      console.log('clicked');
    },
    openGlossaryModal() {
      this.isGlossaryModalOpen = true;
    },
    closeGlossaryModal() {
      this.isGlossaryModalOpen = false;
    },
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    async ensureDataReady() {
      // Check if the user profile is loaded, if not fetch it
      if (!this.getUser) {
        try {
          await this.$store.dispatch('profile/me');
          console.log("User profile data fetched successfully.");
        } catch (error) {
          console.error("Failed to fetch user profile data:", error);
        }
      }
    },
  },
};
</script>
<style scoped>
.tour-hud-overlay {
  position: absolute; /* relative to sidebar container */
  bottom: 8px;
  left: 50%; /* center horizontally */
  transform: translateX(-50%); /* offset by half its own width */

  width: 95%;
  padding: 10px;
  box-sizing: border-box;

  background: #1a1d40;
  border-radius: 18px;
  border: 6px solid white;

  display: flex;
  justify-content: center;
  z-index: 9999;
}


.hud-content {
  width: 100%;
  max-width: 220px; /* shrink to tighter HUD */
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;
}

.step-title {
  font-size: 1.15rem;
  font-weight: 700;
  margin-bottom: 4px;
  color: #ffffff;
}

.step-label {
  font-size: 0.9rem;
  margin-bottom: 8px;
  color: #cfd4e9;
}

.progress-container {
  width: 90%;
  height: 4px;
  background: #2c355b;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 8px;
}

.progress-bar {
  height: 100%;
  background: #6e5ae6; /* Protego primary */
  transition: width 0.3s ease;
}

.button-row {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.nav-arrow {
  background: none;
  border: none;
  color: white;
  font-size: 1.25rem; /* or adjust to your UI */
  font-weight: bold;
  cursor: pointer;
  padding: 0 8px;
}

.nav-arrow:disabled {
  color: rgba(255, 255, 255, 0.3);
  cursor: not-allowed;
}

.nav-arrow:hover:not(:disabled) {
  background: #5842d7;
  border-radius: 6px;
}


.close-button {
  position: absolute;
  top: 4px;
  right: 8px;
  background: none;
  border: none;
  font-size: 18px;
  color: #cfd4e9;
  cursor: pointer;
}






.nav-link {
  margin-left: 7.5% !important;
}

.nav-link {
  position: relative;
  display: flex;
  align-items: center;
  margin-left: 7.5% !important;
}

.nav-link .tooltip-text {
  visibility: hidden;
  width: 140px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 105%; /* Position the tooltip above the text */
  left: 50%;
  margin-left: -70px;
  opacity: 0;
  transition: opacity 0.3s;
}

.nav-link .tooltip-text::after {
  content: "";
  position: absolute;
  top: 100%; /* Arrow at the bottom of the tooltip */
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

.nav-link:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}

.nav-link-coming-soon:hover {
  cursor: url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x-circle"%3E%3Ccircle cx="12" cy="12" r="10"%3E%3C/circle%3E%3Cline x1="15" y1="9" x2="9" y2="15"%3E%3C/line%3E%3Cline x1="9" y1="9" x2="15" y2="15"%3E%3C/line%3E%3C/svg%3E'), auto;
}
</style>
